import { render, staticRenderFns } from "./act-table.vue?vue&type=template&id=aa3b2164&scoped=true"
import script from "./act-table.vue?vue&type=script&lang=js"
export * from "./act-table.vue?vue&type=script&lang=js"
import style0 from "./act-table.vue?vue&type=style&index=0&id=aa3b2164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3b2164",
  null
  
)

export default component.exports